import { SurveyBlock } from '../types/survey'

export const surveyBlocks: SurveyBlock[] = [
  {
    id: 'profile',
    title: 'Bloco 1: Perfil da Empresa',
    description: 'Caracterização do negócio para segmentação dos dados.',
    questions: [
      {
        id: 'q1',
        text: 'Qual o porte da sua empresa?',
        options: [
          { id: 'mei', label: 'Microempreendedor Individual (MEI)', value: 0 },
          { id: 'me', label: 'Microempresa (ME)', value: 0 },
          { id: 'epp', label: 'Empresa de Pequeno Porte (EPP)', value: 0 },
          { id: 'media_grande', label: 'Média ou Grande Empresa', value: 0 },
        ],
      },
      {
        id: 'q2',
        text: 'Qual o setor de atuação principal?',
        options: [
          { id: 'comercio', label: 'Comércio', value: 0 },
          { id: 'servicos', label: 'Serviços', value: 0 },
          { id: 'industria', label: 'Indústria / Transformação', value: 0 },
          { id: 'agronegocio', label: 'Agronegócio', value: 0 },
          { id: 'tecnologia', label: 'Tecnologia / Startups', value: 0 },
        ],
      },
      {
        id: 'q3',
        text: 'Há quanto tempo a empresa atua no mercado?',
        options: [
          { id: 'menos_2', label: 'Menos de 2 anos', value: 0 },
          { id: 'entre_2_5', label: 'Entre 2 e 5 anos', value: 0 },
          { id: 'mais_5', label: 'Mais de 5 anos', value: 0 },
        ],
      },
    ],
  },
  {
    id: 'knowledge',
    title: 'Bloco 2: Conhecimento em PI',
    description:
      'Avaliação do nível de conscientização sobre Propriedade Intelectual.',
    questions: [
      {
        id: 'q4',
        text: 'Como você avalia o seu conhecimento sobre Propriedade Intelectual (Marcas, Patentes, etc.)?',
        options: [
          {
            id: 'nulo',
            label: 'Nulo (Nunca ouvi falar ou não sei o que é)',
            value: 0,
          },
          {
            id: 'basico',
            label: 'Básico (Já ouvi falar, mas não sei como aplicar)',
            value: 1,
          },
          {
            id: 'intermediario',
            label:
              'Intermediário (Conheço os conceitos principais e sua importância)',
            value: 2,
          },
          {
            id: 'avancado',
            label: 'Avançado (Já protegi ativos e utilizo estrategicamente)',
            value: 3,
          },
        ],
      },
      {
        id: 'q5',
        text: 'Você sabe a diferença entre o registro na Junta Comercial (Razão Social) e o registro de Marca no INPI?',
        options: [
          { id: 'sim', label: 'Sim, sei a diferença.', value: 2 },
          { id: 'nao', label: 'Não, achava que era a mesma coisa.', value: 0 },
          { id: 'duvidas', label: 'Tenho dúvidas.', value: 1 },
        ],
      },
      {
        id: 'q6',
        text: 'A sua empresa já buscou, em algum momento, informações sobre como proteger uma marca ou produto?',
        options: [
          { id: 'sim_buscamos', label: 'Sim, buscamos ativamente.', value: 2 },
          { id: 'nao_buscamos', label: 'Não, nunca buscamos.', value: 0 },
          {
            id: 'nao_custo',
            label: 'Não, porque achamos que seria muito caro/burocrático.',
            value: 0,
          },
        ],
      },
    ],
  },
  {
    id: 'practices',
    title: 'Bloco 3: Práticas de Proteção e Inovação',
    description: 'Avaliação das práticas reais de proteção e gestão de ativos.',
    questions: [
      {
        id: 'q7',
        text: 'A marca da sua empresa está registrada no INPI (Instituto Nacional da Propriedade Industrial)?',
        options: [
          {
            id: 'sim_concedido',
            label: 'Sim, o registro já foi concedido (tenho o certificado).',
            value: 3,
          },
          { id: 'andamento', label: 'O processo está em andamento.', value: 2 },
          {
            id: 'nao_pretendo_sim',
            label: 'Não, mas pretendo registrar.',
            value: 1,
          },
          {
            id: 'nao_pretendo_nao',
            label: 'Não, e não pretendo registrar no momento.',
            value: 0,
          },
        ],
      },
      {
        id: 'q8',
        text: 'Sua empresa possui algum segredo de negócio (receita, lista de clientes, método exclusivo) que precisa ser mantido confidencial?',
        options: [
          { id: 'sim', label: 'Sim.', value: 0 }, // Trigger for Q9
          { id: 'nao', label: 'Não.', value: 0 },
          { id: 'nao_sei', label: 'Não sei identificar.', value: 0 },
        ],
      },
      {
        id: 'q9',
        text: 'Você utiliza contratos de confidencialidade (NDA) com funcionários ou parceiros para proteger esses segredos?',
        conditionalOn: { questionId: 'q8', expectedValue: 'sim' },
        options: [
          { id: 'sim_sempre', label: 'Sim, sempre.', value: 3 },
          { id: 'as_vezes', label: 'Às vezes.', value: 1 },
          { id: 'nao_nunca', label: 'Não, nunca utilizamos.', value: 0 },
        ],
      },
      {
        id: 'q10',
        text: 'A empresa lançou algum produto, serviço ou melhoria significativa nos últimos 2 anos?',
        options: [
          { id: 'sim', label: 'Sim.', value: 0 }, // Trigger for Q11
          { id: 'nao', label: 'Não.', value: 0 },
        ],
      },
      {
        id: 'q11',
        text: 'Antes de lançar esse produto/serviço, ou de criar a marca, vocês pesquisaram se já existia algo igual no mercado ou no INPI?',
        conditionalOn: { questionId: 'q10', expectedValue: 'sim' },
        options: [
          {
            id: 'sim_inpi',
            label: 'Sim, pesquisamos no Google e no INPI.',
            value: 3,
          },
          {
            id: 'so_google',
            label: 'Pesquisamos apenas no Google/Redes Sociais.',
            value: 1,
          },
          {
            id: 'nao_pesquisou',
            label: 'Não fizemos pesquisa prévia.',
            value: 0,
          },
        ],
      },
    ],
  },
  {
    id: 'strategy',
    title: 'Bloco 4: Gestão Estratégica',
    description:
      'Avaliação da visão estratégica sobre Propriedade Intelectual.',
    questions: [
      {
        id: 'q12',
        text: 'A Propriedade Intelectual (ex: proteção da marca, exclusividade de produto) é discutida nas reuniões de planejamento da empresa?',
        options: [
          {
            id: 'sim_estrategia',
            label: 'Sim, é parte da estratégia.',
            value: 3,
          },
          { id: 'raramente', label: 'Raramente.', value: 1 },
          { id: 'nunca', label: 'Nunca.', value: 0 },
        ],
      },
      {
        id: 'q13',
        text: 'Você acredita que proteger a Propriedade Intelectual aumentaria o valor ou a competitividade do seu negócio?',
        options: [
          { id: 'sim_totalmente', label: 'Sim, totalmente.', value: 2 },
          { id: 'talvez', label: 'Talvez / Parcialmente.', value: 1 },
          {
            id: 'nao',
            label: 'Não, no meu setor não faz diferença.',
            value: 0,
          },
        ],
      },
    ],
  },
]
